export enum FacingMode {
    User = 'user',
    Environment = 'environment'
}